module.exports = __webpack_public_path__ + "img/012-sao-tome-and-prince.0f059d01.svg";